// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__2lBph"};